export default "__VITE_ASSET__J_Kyk6eg__"